export const NAME_MIN_LENGTH = 5;
export const NAME_MAX_LENGTH = 512;

const ALLOWED_NAME_CHARS = /[^a-zA-Z0-9\s.-]/g;

export const sanitizeName = (value: string): string =>
  value.replace(ALLOWED_NAME_CHARS, '').slice(0, NAME_MAX_LENGTH);

export const isNameValid = (name: string): boolean =>
  name.length >= NAME_MIN_LENGTH;

export const shouldShowNameLengthError = (name: string): boolean =>
  name.length > 0 && name.length < NAME_MIN_LENGTH;
